/**
 * Single Redux store: UI and backend (former "background") live in one tree.
 * - state.backend is one slice; its reducers/sagas/middlewares run in this same store.
 * - All middlewares use the same root store API; no compatibility state adapter.
 */
import { createStore, applyMiddleware } from 'redux';
import createSagaMiddleware from 'redux-saga';
import thunk from 'redux-thunk';
import { persistStore } from 'redux-persist';

import reducers from './reducers/RootReducer';
import sagas from './sagas/RootSaga';
import middlewares, { backendMiddlewares as backendMiddlewareList } from './middlewares/Middlewares';

import { captureException } from '../tracker/raven';

/**
 * onError => catch all errors uncaught in sagas
 *
 * https://docs.sentry.io/clients/javascript/integrations/react/#redux-sagas-middleware
 * https://redux-saga.js.org/docs/api/
 */

const sagaMiddleware = createSagaMiddleware({
    onError: error => {
        console.error(error);
        captureException(error);
    }
});
const middlewareEnhancer = applyMiddleware(thunk, ...middlewares, ...backendMiddlewareList, sagaMiddleware);
export const appStore = createStore(reducers, undefined, middlewareEnhancer);
const persistor = persistStore(appStore);

/* sagaMiddleware HAS to run after createStore */
sagaMiddleware.run(sagas);

const configureStore = () => ({ store: appStore, persistor });

export default configureStore;
